<template>
  <v-card>
    <template>
      <v-card-title class="i-dialog-header-div">
        <span class="g-heading-m g-bold">Update User Role</span>
      </v-card-title>

      <v-card-text class="pt-6 mb-n6 text-center">
        <div class="mb-2">
          <span class="g-text-l">At least 1 role must be selected</span>
        </div>

        <legacy-radio-group
          group-class="c-user-roles"
          item-class="item-div"
          name="user-role"
          :options="USER_ROLES"
          :use-row="false"
          v-model="mutableRole"
        >
          <template #label="{ option }">
            <span>{{ option.text }}</span>
            <v-icon
              class="ml-2 mb-1"
              color="primary"
              small
              v-tooltip="option.tooltipText"
              >mdi-help-circle-outline</v-icon
            >
          </template>
        </legacy-radio-group>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="i-dialog-actions-div justify-center">
        <v-btn rounded text class="i-btn-text-black" @click="handleCancel">
          <strong>Cancel</strong>
        </v-btn>

        <v-btn
          rounded
          class="i-btn-block-secondary"
          @click="handleConfirm"
          :disabled="!isValidChange"
          :loading="loading"
        >
          <strong>Update</strong>
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import LegacyRadioGroup from '@/components/LegacyRadioGroup.vue'
import { updateUserRoles } from '@/services/userAccess'

const USER_ROLES = [
  {
    value: 'ADMIN',
    text: 'Admin',
    tooltipText: 'Access to ALL areas (including My Account functions)'
  },
  {
    value: 'STANDARD',
    text: 'Standard',
    tooltipText:
      'Restricted access to Manage Details, Multiple Account Users, Subscription, Bank Account and Supplier & Brand Logos'
  }
]

export default {
  components: {
    LegacyRadioGroup
  },

  props: {
    user: {
      required: true,
      type: Object
    }
  },

  data: () => ({
    form: false,
    loading: false,
    userRole: null,
    mutableRole: null,
    USER_ROLES
  }),

  computed: {
    isValidChange() {
      return this.hasRole && this.roleModified
    },

    hasRole() {
      return !!this.mutableRole
    },

    roleModified() {
      return this.mutableRole !== this.userRole
    }
  },

  methods: {
    ...mapActions('notifications', ['addNotification']),

    handleCancel() {
      this.$emit('cancel')
    },

    handleConfirm() {
      this.loading = true

      const payload = {
        roles: [this.mutableRole]
      }

      updateUserRoles(this.user.email, payload)
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'User role updated!'
          })
          this.$emit('confirm')
        })
        .catch((err) => {
          let errorMessage = null
          switch (err.response?.data?.code || 'UNKNOWN_ERROR') {
            case 'ACCOUNT_ACCESS_CHANGE_NOT_ALLOWED':
              errorMessage = 'Changes to this user are not allowed...'
              break

            default:
              errorMessage = 'User role could not be updated...'
          }
          this.addNotification({
            color: 'error',
            text: errorMessage
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    getUserRole(user) {
      if (user?.roles.includes(USER_ROLES[0]?.value))
        return USER_ROLES[0]?.value
      else if (user?.roles.includes(USER_ROLES[1]?.value))
        return USER_ROLES[1]?.value
      else return null
    }
  },

  mounted() {
    this.userRole = this.getUserRole(this.user)
    this.mutableRole = this.userRole
  }
}
</script>

<style lang="scss" scoped></style>
